import { INPUT_TYPE } from '@components/dragableTableFrom/formItems';
import { insightModals } from '@model';
import { FORM_KEYS } from './form.keys';

export const INPUT_MAP = {
  [FORM_KEYS.TITLE.key]: {
    inputType: INPUT_TYPE.RICH_TITLE,
    maxLength: insightModals.GUIDING_PRINCIPLE_TITLE_LIMIT,
    placeholder: FORM_KEYS.TITLE.placeholder,
  },
  [FORM_KEYS.DES.key]: {
    inputType: INPUT_TYPE.RICH_TEXT,
    maxLength: insightModals.INSIGHT_LIMIT,
    placeholder: FORM_KEYS.DES.placeholder,
  },
  [FORM_KEYS.DELETE.key]: {
    inputType: INPUT_TYPE.DELETE,
  },
  [FORM_KEYS.DRAG.key]: {
    inputType: INPUT_TYPE.DRAG,
  },
};
